// services/externalProviderService.js
import { BASE_URL } from "../constants";
import { getAuthHeader } from "../utils";

export const externalProviderService = {
  // Crear prestador externo (asociado a un caso médico)
  createExternalProvider: async (providerData) => {
    console.log("📤 Enviando prestador externo a /insurance/external-providers/:", providerData);

    try {
      const res = await fetch(`${BASE_URL}insurance/external-providers/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...getAuthHeader(),
        },
        body: JSON.stringify(providerData),
      });

      const textResponse = await res.text();
      console.log("📥 Respuesta completa:", textResponse);

      let data;
      try {
        data = JSON.parse(textResponse);
      } catch (e) {
        console.error("❌ La respuesta no es JSON:", textResponse.substring(0, 500));
        throw new Error("Error interno del servidor (respuesta HTML)");
      }

      if (!res.ok) {
        let errorMessage = "Error al crear prestador externo";
        if (data.detail) errorMessage = data.detail;
        else if (data.error) errorMessage = data.error;
        throw new Error(errorMessage);
      }

      return data;
    } catch (error) {
      console.error("❌ Error en createExternalProvider:", error);
      throw error;
    }
  },

  // Obtener prestadores externos de un caso médico
  getByMedicalCase: async (medicalCaseId) => {
    const res = await fetch(
      `${BASE_URL}insurance/external-providers/?medical_case=${medicalCaseId}`,
      {
        headers: {
          "Content-Type": "application/json",
          ...getAuthHeader(),
        },
      }
    );

    const data = await res.json();
    if (!res.ok) throw new Error(data.error || "Error al cargar prestadores externos");

    return data.results || data;
  },

  // Obtener un prestador externo por ID
  getById: async (id) => {
    const res = await fetch(`${BASE_URL}insurance/external-providers/${id}/`, {
      headers: {
        "Content-Type": "application/json",
        ...getAuthHeader(),
      },
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data.error || "Error al cargar prestador externo");
    return data;
  },

  // Actualizar prestador externo
  update: async (id, providerData) => {
    const res = await fetch(`${BASE_URL}insurance/external-providers/${id}/`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        ...getAuthHeader(),
      },
      body: JSON.stringify(providerData),
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data.error || "Error al actualizar prestador externo");
    return data;
  },

  // Eliminar prestador externo
  delete: async (id) => {
    const res = await fetch(`${BASE_URL}insurance/external-providers/${id}/`, {
      method: "DELETE",
      headers: {
        ...getAuthHeader(),
      },
    });

    if (!res.ok) {
      const data = await res.json();
      throw new Error(data.error || "Error al eliminar prestador externo");
    }
    return { success: true };
  },
};

/**
 * Obtener prestador externo de un caso médico
 * @param {number | string} medicalCaseId - ID del caso médico
 * @returns {Promise<Object|null>} Primer prestador externo o null si no existe
 */
export async function getExternalProviderByCase(medicalCaseId) {
  const res = await fetch(
    `${BASE_URL}insurance/external-providers/?medical_case=${medicalCaseId}`,
    {
      headers: {
        "Content-Type": "application/json",
        ...getAuthHeader(),
      },
    }
  );

  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.detail || "Error al cargar prestador externo");
  }

  const data = await res.json();
  
  // Tomar el primer proveedor si existe
  if (Array.isArray(data) && data.length > 0) {
    return data[0];
  } else if (data.results && data.results.length > 0) {
    return data.results[0];
  }
  
  return null;
}